import { render } from "./PartyMassWorkDetail.vue?vue&type=template&id=122372d4&scoped=true"
import script from "./PartyMassWorkDetail.vue?vue&type=script&lang=js"
export * from "./PartyMassWorkDetail.vue?vue&type=script&lang=js"

import "./PartyMassWorkDetail.vue?vue&type=style&index=0&id=122372d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122372d4"]])

export default __exports__